// src/encounter/services/use-leave-guard.ts
//
// D-73 (design desk, 6 Oct 2026, amended): leaving the encounter while a note save is pending or failed asks first.
// This is the browser half — the leave-page prompt when the tab closes, reloads or the address changes (the copy is
// the browser's own; no page can set it). Frame v2 only tonight; the in-app confirm for in-app navigation follows.
import { useEffect } from 'react';

export function useLeaveGuard(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // Legacy assignment some browsers still need to show the prompt.
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [active]);
}
